import React, { memo } from 'react';
import { isMobile, notificationStore } from '@pascal/pascal-core';
import {
  AdditionalResponseCode,
  betInputPlusOrMinus,
  globalTranslationKeys,
  numPadTypes,
} from '../../../../enums';

export const BaseBetAmount = memo(
  ({
    handleBaseBetAmount,
    autoPlayAmountParams,
    onChangeBaseBate,
    onBlur,
    baseBetAmount,
    handleOpenNumPad,
    t,
  }) => {
    return (
      <div className='sec-row-inner-bl'>
        <p className='small-text' title={t(globalTranslationKeys.BaseBet)}>
          {t(globalTranslationKeys.BaseBet)}
        </p>
        <div className='bet-inpt-box big'>
          <div className='bet-inpt-box-inner'>
            <div
              className='bet-inpt-rulers'
              onClick={() => {
                if (baseBetAmount <= autoPlayAmountParams.minValue) {
                  notificationStore.setNotificationType({
                    responseCode: AdditionalResponseCode.InValidMinBet,
                  });
                }
                handleBaseBetAmount(betInputPlusOrMinus.minus);
              }}
            >
              <span className=' ui-lib-minus' />
            </div>
            <input
              className='bet-opt-inp'
              type='text'
              maxLength='9'
              inputMode='none'
              value={baseBetAmount}
              onChange={onChangeBaseBate}
              onBlur={onBlur}
              onPaste={(e) => {
                e.preventDefault();
                return false;
              }}
              {...(isMobile()
                ? {
                    onClick: (e) =>
                      handleOpenNumPad(e, numPadTypes.baseBetAmount, null, autoPlayAmountParams),
                  }
                : {})}
            />
            <div
              className='bet-inpt-rulers'
              onClick={() => {
                if (baseBetAmount >= autoPlayAmountParams.maxValue) {
                  notificationStore.setNotificationType({
                    responseCode: AdditionalResponseCode.InValidMaxBet,
                  });
                }
                handleBaseBetAmount(betInputPlusOrMinus.plus);
              }}
            >
              <span className=' ui-lib-plus' />
            </div>
          </div>
        </div>
      </div>
    );
  }
);
